module.exports = __webpack_public_path__ + "img/ajax-loader.78a563f.gif";